import { FC } from 'react';

const PinIcon: FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.0496 17.4499C15.4696 17.0299 15.7596 16.4999 15.8696 15.9099L16.3396 13.5599C16.3796 13.3699 16.4696 13.1899 16.6096 13.0499L19.7196 9.93989L20.4296 10.6499L21.8496 9.22989L14.7596 2.13989L13.3396 3.55989L14.0496 4.26989L10.9396 7.37989C10.7996 7.51989 10.6196 7.60989 10.4296 7.64989L8.07965 8.12989C7.49965 8.23989 6.96965 8.52989 6.54965 8.94989L4.13965 11.3599L7.67965 14.8999L4.13965 18.4399L5.55965 19.8599L9.09965 16.3199L12.6396 19.8599L15.0496 17.4499ZM12.6496 17.0199L6.97965 11.3499L7.96965 10.3599C8.10965 10.2199 8.28965 10.1299 8.47965 10.0899L10.8296 9.61989C11.4096 9.49989 11.9496 9.21989 12.3696 8.79989L15.4796 5.68989L18.3096 8.51989L15.1996 11.6299C14.7796 12.0499 14.4896 12.5799 14.3796 13.1699L13.9096 15.5199C13.8696 15.7099 13.7796 15.8899 13.6396 16.0299L12.6496 17.0199Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PinIcon;
